import ActiveService from '@/service.active';

class uploadedVehiclesService extends ActiveService{
  constructor(
    $injector,
    $auth,
    CONFIG,
    $translates
  ){
    'ngInject';

    super( $injector );
    this.$translates = $translates;
    this.$auth = $auth;
    this.CONFIG = CONFIG;

    this.selectedCompany = null;
    this.allOperators = [];
  }

  set company(val) {
    this.selectedCompany = val;
  }

  fetchAll() {
    return this.activeGet(INVOICE_ACCOUNTS_URI);
  }

  getAllOperators() {
    this.activeGet(this.CONFIG.API.operators)
			.then(operator => this.allOperators = operator.sort((a, b) => a.operator_display_name - b.operator_display_name));
  }

  getOperators() {
		return this.activeGet(this.selectedCompany.uris.CompanyOperators)
			.then(operators => this.allOperators.filter(d => operators.includes(d.operator_code)));
	}

  getUploadedVehicles() {
    return this.activeGet(this.selectedCompany.uris.UploadedVehicles);
  }

  saveUploadedVehicles(data) {
    return this.activePost(this.selectedCompany.uris.UploadedVehicles, {uploaded_vehicles: data})
      .then( () => this.notify.set(this.$translates.get('UPLOADED_VEHICLES_CREATED_SUCCESS'), 'success'))
  }

}

export default uploadedVehiclesService;


/** WEBPACK FOOTER **
 ** ./frontend/components/uploadedVehicles/uploadedVehicles.service.js
 **/